import { render, staticRenderFns } from "./AdminCampaignPausedActionsPrompt.vue?vue&type=template&id=5d1fc3f0&scoped=true"
import script from "./AdminCampaignPausedActionsPrompt.vue?vue&type=script&lang=js"
export * from "./AdminCampaignPausedActionsPrompt.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaignPausedActionsPrompt.vue?vue&type=style&index=0&id=5d1fc3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fc3f0",
  null
  
)

export default component.exports